import type { Currency, FamilyMember, FamilyRole } from "../api/types"

export const ROLE_RANK: Record<FamilyRole, number> = {
  OWNER: 30,
  ADMIN: 20,
  MEMBER: 10
}

export function atLeast(role: FamilyRole | undefined, expected: FamilyRole) {
  return role ? ROLE_RANK[role] >= ROLE_RANK[expected] : false
}

export function canManageFamily(role?: FamilyRole) {
  return atLeast(role, "ADMIN")
}

export function canReward(role?: FamilyRole) {
  return atLeast(role, "ADMIN")
}

export function activeAccountMembers(members: FamilyMember[]) {
  return members.filter(
    (member) =>
      member.status === "ACTIVE" &&
      (member.hasAccount ?? Boolean(member.userId ?? member.user)) &&
      (member.accountStatus ?? member.user?.status) === "ACTIVE"
  )
}

export function canUseCurrency(
  currency: Currency,
  role: FamilyRole | undefined,
  action: "view" | "issue" | "transfer" | "spend" | "penalize",
  memberId?: string
) {
  if (!role) return false
  if (currency.scope === "PAIR") {
    if (action === "transfer") return false
    if (action === "issue" || action === "penalize") return memberId === currency.pairIssuerMemberId
    if (action === "spend") return memberId === currency.pairHolderMemberId
  }
  if (action === "transfer" && currency.scope !== "PORTABLE") return false
  const key = `${action}Roles`
  const configured = currency.policy?.[key]
  if (configured) return configured.includes(role)
  if (action === "view") return true
  if (action === "issue" || action === "penalize") return canReward(role)
  return true
}
